export default __webpack_public_path__ + "static/media/check-icon.08700c3a.svg";